import React from "react";
import axios from "axios";

import * as Globals from "./../Globals";
import ResultSubject from "./ResultSubject";

export default class TestProtocol extends React.Component {
  constructor(props) {
    super(props);

    this.resultID = this.props.id;
    this.gradingSystems = [];
    this.state = {
      subjects: [],
      mark: this.props.mark
    };
  }

  loadQuestions() {
    let cookie = this.props.LogoutOnCookieNotSet();
    axios
      .get(
        `${Globals.EL_PATH}testresult/${this.resultID}/testresult_question?Authentication=${cookie}`
      )
      .then(response => {
        this.setState({
          questions: response.data.records
        });
      })
      .catch(error => {
        this.props.CheckAuthError(error);
      });
  }

  componentDidMount() {
    // this.loadQuestions()
    let cookie = this.props.LogoutOnCookieNotSet();
    axios
      .get(`${Globals.EL_PATH}testresult/${this.resultID}/subjects?Authentication=${cookie}`)
      .then(response =>
        this.setState({
          subjects: response.data.records
        })
      )
      .catch(error => {
        this.props.CheckAuthError(error);
      });
    this.updateGradingSystem();
  }

  updateGradingSystem() {
    let cookie = this.props.LogoutOnCookieNotSet();
    axios
      .get(`${Globals.EL_PATH}testresult/${this.resultID}/gradingsystem?Authentication=${cookie}`)
      .then(response => {
        this.gradingSystems = response.data.records;
        this.forceUpdate();
      })
      .catch(error => {
        this.props.CheckAuthError(error);
        if (error.response.data.message === "No testresults found.") {
          this.testResultIDs = [];
          this.forceUpdate();
        }
      });
  }

  changeGradingSystem(e) {
    this.setState({
      mark: e.target.value
    });
  }

  unlock() {
    if (this.gradingSystems.indexOf(this.state.mark) !== -1) {
      let cookie = this.props.LogoutOnCookieNotSet();
      axios
        .put(Globals.EL_PATH + "testresult/" + this.resultID + "/unlock?Authentication=" + cookie, {
          MARK: this.state.mark
        })
        .then(() => this.props.sendTestsRequest())
        .catch(error => {
          this.props.CheckAuthError(error);
        });
    } else {
      this.updateGradingSystem();
    }
  }

  render() {
    return (
      <div>
        <h4 className="text-center margin-bottom-md">{this.props.name}</h4>
        {this.state.subjects.map(subject => (
          <ResultSubject
            CheckAuthError={this.props.CheckAuthError}
            LogoutOnCookieNotSet={this.props.LogoutOnCookieNotSet}
            key={subject.id}
            subject={subject}
            resultId={this.resultID}
          />
        ))}
        <div className="overflow-hidden">
          <label className="float-left dropDownGradesLabel">Benotung:</label>
          <select
            className="form-control float-left dropDownGrades"
            id="gradingSystem"
            value={this.state.mark}
            onChange={e => this.changeGradingSystem(e)}
          >
            {this.gradingSystems.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>
        <div className="margin-top-sm">
          <button
            className="btn btn-success float-left"
            type="button"
            onClick={() => this.unlock()}
          >
            Signieren
          </button>
          <button
            className="btn btn-info float-right"
            type="button"
            onClick={() => this.props.sendTestsRequest()}
          >
            Protokoll schließen
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/TestProtocol.js